import styled from "styled-components";

const Hover = styled.span`
  cursor: pointer;
  color: var(--primary-text-color);
  font-weight: 500;
`;

export default Hover;
